//-- Copyright (c) 2021 TMT Insights Group, LLC
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { setCurrentTable } from '@/redux/slices/dataTableSlice';
import { selectCurrentTableKey } from '@/redux/selectors/dataTableSelectors';
import DataTableFilters from '@/components/_common/Filters/DataTableFilters';
import DataTableLayout from '@/components/_common/Layout/DataTableLayout';
import ReportsTitleBar from './ReportsTitleBar';
import FiltersContainer from '@/components/Focus/common/FiltersContainer';

const Reports = () => {
  const dispatch = useAppDispatch();
  const currentTableKey = useAppSelector(selectCurrentTableKey);

  useEffect(() => {
    dispatch(setCurrentTable('focusReports'));
  }, []);

  return (
    <>
      {currentTableKey === 'focusReports' && (
        <DataTableLayout tableKey="focusReports">
          <ReportsTitleBar />
          <FiltersContainer>
            <DataTableFilters disableExportReport />
          </FiltersContainer>
        </DataTableLayout>
      )}
    </>
  );
};

export default Reports;
